import api from '../../apiConfig/apiConfig';
import { Post, Get, Patch, Delete } from '../base/baseAjax';
export function getTaskDetail(id) {
  return Get({
    url: api.task.getTaskDetail + id,
  });
}
export function getSubTaskList(id) {
  return Post({
    url: `${api.task.getSubTaskList}${id}/list`,
  });
}
export function editTaskDetail(id, param) {
  return Patch({
    url: `${api.task.editTaskDetail}${id}`,
    bodyParam: param,
  });
}
export function getTaskGroup() {
  return Post({
    url: api.task.getTaskGroup,
  });
}
export function addFile(param) {
  return Post({
    url: api.task.addFile,
    bodyParam: param,
  });
}
export function removeFile(id) {
  return Delete({
    url: `${api.task.removeFile}/${id}`,
  });
}
export function getTaskFlowList(param) {
  return Get({
    url: `${api.task.getTaskFlowList}`,
    UrlParam: param,
  });
}

export function getTaskbanList(param) {
  return Post({
    url: api.task.taskbanList,
    bodyParam: param,
  });
}

export function getStaff(param) {
  return Get({
    url: api.task.getStaff,
    UrlParam: param,
  });
}

export function getStatistics(param) {
  return Get({
    url: api.task.getStatistics,
    UrlParam: param,
  });
}

export function previewInform(params) {
  return Post({
    url: api.task.previewInform,
    bodyParam: params,
  });
}

export function batchAppoint(params) {
	return Patch({
		url: api.task.batchAppoint,
		bodyParam: params,
	});
}

export default {
	getTaskDetail,
	getSubTaskList,
	editTaskDetail,
	getTaskGroup,
	addFile,
	removeFile,
	getTaskFlowList,
	getTaskbanList,
	getStaff,
	getStatistics,
	previewInform,
	batchAppoint,
};
